import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
// Redux
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

// Component
import CurrencyConverter from '../../CurrencyConverter';

// Locale
import messages from '../../../locale/jsonMessages';

import cs from '../../commonStyle.css';
import s from '../ViewMessage.css';

const ClaimDetails = (props) => {

    const { reservationData, openModal } = props;

    let claimStatus, claimAmount = 0, securityDeposit = 0, claimPayout = 0, claimRefund = 0, currency;
    if (reservationData) {
        claimStatus = reservationData.claimStatus;
        claimAmount = reservationData.claimAmount;
        securityDeposit = reservationData.securityDeposit;
        claimPayout = reservationData.claimPayout;
        claimRefund = reservationData.claimRefund;
        currency = reservationData.currency;
    }

    return (
        <div>
            <h4 className={cx(s.space3, s.marginTop0, s.tripDetails)}>
                <span><FormattedMessage {...messages.claimDetails} /></span>
            </h4>
            {
                securityDeposit > 0 &&
                <div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
                    <div className={cx(cs.commonSmallText16, cs.textStart)}>
                        <FormattedMessage {...messages.securityDepositClaim} />
                    </div>
                    <div className={cx(cs.commonSmallText16, cs.textEnd)}>
                        <CurrencyConverter
                            amount={securityDeposit}
                            from={currency}
                        />
                    </div>
                </div>
            }

            {
                <div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
                    <div className={cx(cs.commonSmallText16, cs.textStart)}>
                        <FormattedMessage {...messages.claimedByOwnerClaim} />
                    </div>
                    <div className={cx(cs.commonSmallText16, cs.textEnd)}>
                        <CurrencyConverter
                            amount={claimAmount}
                            from={currency}
                        />
                    </div>
                </div>
            }

            {
                <div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
                    <div className={cx(cs.commonSmallText16, cs.textStart)}>
                        <span><FormattedMessage {...messages.claimAmountSharedToOwner} /></span>
                    </div>
                    <div className={cx(cs.commonSmallText16, cs.textEnd)}>
                        <CurrencyConverter
                            amount={claimPayout}
                            from={currency}
                        />
                    </div>
                </div>
            }
            {
                <div className={cx(cs.dataTableGrid)}>
                    <div className={cx(cs.commonSmallText18, cs.fontWeightBold, cs.textStart)}>
                        <FormattedMessage {...messages.claimRefundedMessage} />
                        <div>{securityDeposit > 0 && claimAmount > 0 && <a className={s.link} onClick={openModal}>{' ('}<FormattedMessage {...messages.claimDetails} />{')'}</a>}</div>
                    </div>
                    <div className={cx(cs.commonSmallText18, cs.fontWeightBold, cs.textEnd)}>
                        <CurrencyConverter
                            amount={claimRefund}
                            from={currency}
                        />
                    </div>
                </div>
            }
        </div>
    );
}

export default withStyles(cs, s)(ClaimDetails);

